const actions: Record<string, string> = {
  "family.created": "Семья создана",
  "family.invitation.created": "Создано приглашение",
  "family.invitation.accepted": "Приглашение принято",
  "family.invitation.revoked": "Приглашение отозвано",
  "family.member.role_changed": "Изменена роль участника",
  "family.member.status_changed": "Изменён доступ участника",
  "family.member.two_factor_reset": "Сброшена двухфакторная защита",
  "currency.created": "Создана семейная валюта",
  "currency.issued": "Начислена валюта",
  "currency.transferred": "Выполнен перевод",
  "currency.spent": "Списана валюта",
  "penalty.applied": "Назначен штраф",
  "achievement.created": "Создана ачивка",
  "achievement.awarded": "Вручена ачивка",
  "item.created": "Создан легендарный предмет",
  "item.granted": "Выдан легендарный предмет",
  "item.use_requested": "Запрошено использование предмета",
  "item.use_approved": "Использование предмета подтверждено",
  "item.use_rejected": "Использование предмета отклонено",
  "item.used": "Легендарный предмет использован",
  "automation.created": "Создано автоматическое правило",
  "automation.updated": "Изменено автоматическое правило"
}

const targets: Record<string, string> = {
  Family: "семья",
  FamilyMember: "участник",
  FamilyInvitation: "приглашение",
  Currency: "валюта",
  AchievementDefinition: "ачивка",
  LegendaryItemDefinition: "предмет",
  AutomationRule: "правило"
}

export function auditActionLabel(action: string) {
  if (actions[action]) return actions[action]
  return action
    .split(".")
    .map((part) => part.replaceAll("_", " "))
    .join(" · ")
}

export function auditTargetLabel(target?: string) {
  if (!target) return "семья"
  return targets[target] ?? target.replaceAll("_", " ").toLocaleLowerCase("ru")
}
